import React, { useMemo } from 'react';

interface VirtualListProps<T> {
  items: T[];
  itemHeight: number; // px
  height: number; // container height px
  renderItem: (item: T, index: number) => React.ReactNode;
}

export function VirtualList<T>({ items, itemHeight, height, renderItem }: VirtualListProps<T>) {
  const [scrollTop, setScrollTop] = React.useState(0);
  const onScroll = (e: React.UIEvent<HTMLDivElement>) => {
    setScrollTop((e.target as HTMLDivElement).scrollTop);
  };

  const { start, end, paddingTop, paddingBottom } = useMemo(() => {
    const startIndex = Math.max(0, Math.floor(scrollTop / itemHeight) - 5);
    const visibleCount = Math.ceil(height / itemHeight) + 10; // buffer
    const endIndex = Math.min(items.length, startIndex + visibleCount);
    const top = startIndex * itemHeight;
    const bottom = (items.length - endIndex) * itemHeight;
    return { start: startIndex, end: endIndex, paddingTop: top, paddingBottom: bottom };
  }, [scrollTop, itemHeight, height, items.length]);

  const slice = items.slice(start, end);

  return (
    <div style={{ height, overflowY: 'auto' }} onScroll={onScroll}>
      <div style={{ paddingTop, paddingBottom }}>
        {slice.map((item, i) => renderItem(item, start + i))}
      </div>
    </div>
  );
}

